const NotFoundPage = () => 
{
    return (
        <div className="flex flex-grow relative text-6xl font-bold justify-center items-center">Error 404: Page is not found</div>
    )
}

export default NotFoundPage;